
(function () {
  'use strict';
  
  /**
   * @ngdoc service
   * @name vcexamtemplate.factory:ExamtemplateHelper
   *
   * @description
   *
   */
  angular
    .module('vcexamtemplate')
    .factory('ExamtemplateHelper', ExamtemplateHelper);
  
  
  ExamtemplateHelper.$inject = ['Examtemplate', '$uibModal', '$log', 'Rlog'];
  
  function ExamtemplateHelper(Examtemplate, $uibModal, $log, Rlog) {
    let ExamtemplateHelperBase = {};
    let sampletemplate = {
      type: 'newexam',
      displayname: 'Neue Untersuchung',
      device: {label: 'Ger&auml;t', name: ''},
      loadfiles: false,
      shareid: '',
      fieldgroups: [
        {
          label: 'Untersuchungsdaten',
          fields: [
            {label: 'Untersuchender Arzt', avalues: [], values: []},
            {label: 'Assistenz', avalues: [], values: []},
            {label: 'Sedierung', avalues: [], values: []},
            {label: 'Narkose', avalues: [], values: []}
          ]
        },
        {
          label: 'Feldgruppe1',
          fields: [
            {label: 'Neues Feld', avalues: [], values: []},
            {label: 'Neues Feld', avalues: [], values: []}
          ]
        },
        {
          label: 'Feldgruppe2',
          fields: [
            {label: 'Neues Feld', avalues: [], values: []},
            {label: 'Neues Feld', avalues: [], values: []}
          ]
        }
      ],
      biopsy: {
        label: 'Biopsien',
        values: [],
        biopsies: [{label: '', avalues: [], values: []}]
      },
      comment: {label: 'Anmerkungen', avalues: [], values: []},
      diagnosis: {label: 'Zusammenfassung', avalues: [], values: []},
      recommendation: {label: 'Empfehlung', avalues: [], values: []}
    };
    ExamtemplateHelperBase.editExamtemplate = editExamtemplate;
    ExamtemplateHelperBase.addExamtemplate = addExamtemplate;
    ExamtemplateHelperBase.getSampleTemplate = getSampleTemplate;



    
    function addExamtemplate(success, error) {
      let dialog = $uibModal.open({
        template: '<div class="modalspacer"><examtemplateform examtemplate="vm.examtemplate" parentsave="vm.childsave(examtemplate)" oncancel="vm.cancel()"></examtemplatenew></div>',
        controllerAs: 'examtemplateaCtrl',
        controller: ['examtemplate', function () {
          let vm = this;
          vm.examtemplate = {};
          
          vm.childsave = childsave;
          vm.cancel = cancel;
          
          function childsave(examtemplate) {
            Examtemplate.$create(examtemplate).$then(function (newexamtemplate) {
              vm.created = true;
              success(newexamtemplate);
              dialog.close();
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new SV failed @ examtemplate-helper.addExamtemplate: ', err);
              Rlog.error('vcutils.examtemplate', 'examtemplate-helper.addExamtemplate', 'Creation of new SV failed: ', {error: err, examtemplate: examtemplate});
              error(err);
              dialog.close();
            });
          }
          
          function cancel() {
            dialog.close();
          }
          
        }],
        resolve: {
          examtemplate: function () {
            return {};
          }
        },
        size: 'lg'
      });
    }

    function editExamtemplate(lexamtemplate) {
      let dialog = $uibModal.open({
        template: '<div class="modalspacer"><examtemplateform examtemplate="examtemplateeCtrl.examtemplate" parentsave="examtemplateeCtrl.childsave(examtemplate)" oncancel="examtemplateeCtrl.cancel()"></examtemplateform></div>',
        controllerAs: 'examtemplateeCtrl',
        controller: ['examtemplate', function (lexamtemplate) {
          let vm = this;
          vm.examtemplate = lexamtemplate;
          vm.childsave = childsave;
          vm.cancel = cancel;
          
          
          function childsave(examtemplate) {
            // vm.examtemplate = angular.copy(examtemplate);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (let key in examtemplate) {
              if (examtemplate.hasOwnProperty(key)) {
                vm.examtemplate[key] = examtemplate[key];
              }
            }
            
            if (vm.examtemplate.$hasPendingActions()) {
              vm.examtemplate.$cancel();
              vm.examtemplate.$save();
              cancel();
            }
            else {
              vm.examtemplate.$save();
              dialog.close();
            }
          }
          
          
          function cancel() {
            dialog.close();
          }
          
          
        }],
        resolve: {
          examtemplate: function () {
            return lexamtemplate;
          }
        },
        size: 'lg'
      });
      return dialog;
    }

    function getSampleTemplate(){
      return sampletemplate;
    }
    
    return ExamtemplateHelperBase;
  }
}());
